module.exports = __webpack_public_path__ + "static/media/WorkFlow.580ffaaa.jpg";